import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-download-lite',
  templateUrl: './download-lite.component.html',
  styleUrls: ['./download-lite.component.scss']
})
export class DownloadLiteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
